import type { ReactElement } from 'react';
import { useServices, useT } from '../../../app/di';
import { useResource } from '../../../shared/hooks';
import { Card } from '../../../ui-kit/Card/Card';
import { Loading } from '../../../ui-kit/Loading/Loading';
import { useBlog } from '../../accounts/workspaces';
import { PostFieldsForm } from './PostFieldsForm/PostFieldsForm';

// ENT-UC-4
export function PostFieldsSection(): ReactElement {
  const { api } = useServices();
  const { t } = useT();
  const { blog } = useBlog();
  const current = useResource(() => api.entities.postFields(blog.id), [api, blog.id]);
  const types = useResource(() => api.entities.types(blog.id), [api, blog.id]);

  return (
    <Card title={t('entities.postFields.title')}>
      <div className="u-stack">
        <p className="u-muted u-small">{t('entities.postFields.subtitle')}</p>
        {current.loading && !current.data ? (
          <Loading label={t('common.loading')} />
        ) : (
          <PostFieldsForm
            fields={current.data ?? []}
            entityTypes={types.data ?? []}
            onSubmit={async (fields) => {
              const result = await api.entities.savePostFields(blog.id, fields);
              if (result.success) current.setData(result.data);
              return result;
            }}
          />
        )}
      </div>
    </Card>
  );
}
